export const FAQsArr = [
  {
    title: "Is a deep bite just a cosmetic concern?",
    definition:
      "A deep bite might initially be identified due to its visual impact. However, it often carries several health concerns, including accelerated upper and lower front teeth wear, potential jaw discomfort, gum recession, and increased risk of chipping the front teeth.",
  },
  {
    title: "Can a deep bite correct itself over time?",
    definition:
      "Deep bites typically do not resolve on their own, and if left untreated, they can worsen and lead to further orthodontic issues. Factors such as tooth wear or habits like teeth grinding can sometimes exacerbate the condition in adults.",
  },
  {
    title: "Is a deep bite the same as an overbite?",
    definition:
      "‘Deep bite’ and ‘overbite’ are often used interchangeably to describe a malocclusion where the upper front teeth significantly cover the lower front teeth vertically. This is often confused with an overjet, which refers to the horizontal distance between the upper and lower front teeth. Commonly known as ‘buck teeth,’ overjet occurs when the upper front teeth extend forward at an angle, whereas an overbite or deep bite occurs when the upper front teeth vertically cover the bottom front teeth.",
  },
  {
    title: "What complications can arise from an untreated crossbite?",
    definition:
      "If overlooked, crossbites can trigger jaw misalignment, uneven jaw growth, premature wearing of the tooth enamel, facial asymmetry, and improper chewing, among other dental issues.",
  },
  {
    title: "Is a crossbite the same as an underbite or overbite?",
    definition:
      "No, not all crossbites are the same. A crossbite represents a form of malocclusion, characterized by a misalignment of teeth where the upper teeth fit inside the lower teeth. This misalignment can impact individual teeth or groups of teeth, encompassing the front, back, or both sets. In a posterior crossbite, the back teeth are affected, with upper teeth situated inside the lower teeth. Conversely, an anterior crossbite involves the front teeth, where one or more upper teeth are positioned behind the lower teeth. It’s important to distinguish this from an underbite, where either the upper teeth or jaw are positioned behind the lower teeth.",
  },
  {
    title: "How can I tell if my child or I have a crossbite?",
    definition:
      "The prominent indication of a crossbite is when the upper teeth fit inside the lower teeth in the back and/or the front when biting down normally. Should you suspect a crossbite, seeking a professional evaluation from an orthodontist is imperative to ensure treatment is started at the optimal age.",
  },
  {
    title: "Is it harder to maintain oral hygiene with braces?",
    definition:
      "Braces can present some challenges in cleaning, but with the right tools and techniques, you can maintain excellent oral hygiene. Brushing and flossing, as usual, remain important.",
  },
  {
    title: "Will orthodontic treatment be painful?",
    definition:
      "While there might be some discomfort initially or after adjustments, most people adapt quickly. Discomfort is usually manageable with over-the-counter pain relievers.",
  },
  {
    title: "How long will my treatment last?",
    definition:
      "Treatment duration varies depending on the severity of the issue and the type of treatment. Your orthodontist will be able to provide the most accurate timeline for your treatment.",
  },
  {
    title: "Do I need to wear my retainer forever?",
    definition:
      "Retainers help maintain the results of braces or aligners. Your orthodontist will likely advise you to wear your retainer for an extended period.",
  },
  {
    title: "Does orthodontic treatment take longer as an adult?",
    definition:
      "Compared to children, your timeline for orthodontic treatment may be longer. Adult teeth are more firmly set in the jaw than younger candidates. It takes more time and pressure to move teeth to their desired position.",
  },
  {
    title: "Does insurance cover adult orthodontics?",
    definition:
      "Some dental insurance plans offer an annual or lifetime maximum benefit for adult orthodontics. Unfortunately, most dental plans do not provide coverage. However, in some cases, orthodontics can be a medical necessity. If referred by your dentist because of a medical issue, you should attempt to verify coverage with your medical healthcare insurance provider. If you plan to get orthodontic treatment, contributing to an HSA or FSA account can help finance your treatment.",
  },
  {
    title: "Are there different mouthguard designs for different sports?",
    definition:
      "Yes, some mouthguards are designed with specific sports in mind, offering varying levels of protection. High-contact sports like football or hockey might require a more robust mouthguard than non-contact sports.",
  },
  {
    title: "How can I prevent my mouthguard from smelling bad?",
    definition:
      "Regular cleaning and proper storage are essential. Dry your mouthguard thoroughly before storing it. A mouthguard cleaning solution or a mixture of water and mild soap can also help keep it fresh.",
  },
  {
    title: "Can I wear my mouthguard while sleeping?",
    definition:
      "While sports mouthguards aren’t typically designed for nighttime wear, special mouthguards are made for nocturnal teeth grinders (bruxism). If you’re concerned about grinding teeth overnight, consult your orthodontist for the best solution.",
  },
  {
    title: "What should I do if my mouthguard doesn’t fit correctly?",
    definition:
      "Consult your orthodontist if your mouthguard is causing discomfort or doesn’t fit properly. They can advise whether adjustments can be made or if a new one is needed.",
  },
  {
    title: "Is it okay to share my mouthguard with someone else?",
    definition:
      "For hygiene reasons, you should never share your mouthguard with others. Sharing can also lead to a poor fit, reducing the mouthguard’s effectiveness and potentially causing discomfort.",
  },
  {
    title: "Can I speak clearly with a mouthguard?",
    definition:
      "Initially, speaking with a mouthguard might feel odd, but with time and practice, most individuals adapt. Due to their precise fit, custom-fitted mouthguards often cause less speech disruption than bulkier, over-the-counter varieties.",
  },
  {
    title: "How often should I replace my mouthguard?",
    definition:
      "While a mouthguard can last several years with proper care, it’s advisable to replace it after a significant growth spurt, a dental procedure, or if it shows signs of wear and tear. Athletes or those frequently involved in contact sports might need to replace theirs more regularly.",
  },
  {
    title: "What’s the right way to care for my mouthguard?",
    definition:
      "Regular cleaning, proper storage, and periodic inspection are essential to prolong the lifespan and effectiveness of your mouthguard.",
  },
  {
    title: "Can I eat with my retainer on?",
    definition:
      "It is recommended to take out removable retainers while eating to prevent potential damage. For fixed retainers, avoid consuming hard or sticky foods that may dislodge the wire.",
  },
  {
    title: "What do I do if I lose or break my retainer?",
    definition:
      "If lost or broken, contact your orthodontist immediately. Getting a replacement or fixing it is crucial to avoid teeth shifting.",
  },
  {
    title: "How long should I wear my retainer each day?",
    definition:
      "The duration varies depending on the advice of your orthodontist and the stage of your post-treatment. Always follow your orthodontist’s recommendations to ensure the stability and longevity of your orthodontic results.",
  },
  {
    title: "Why does my retainer feel snug or tight?",
    definition:
      "If your retainer feels tight, it might indicate that your teeth have shifted slightly. It’s essential to wear your retainer as instructed to prevent such shifting. If the tightness causes discomfort or pain, consult your orthodontist for advice.",
  },
  {
    title: "How do I prepare a hesitant child for braces?",
    definition:
      "For parents considering braces for their children, it’s essential to prepare them for this journey. Speak positively about the experience, emphasizing the benefits. Let them know the orthodontist and their team will do everything possible to make the process go as smoothly as possible. Books and videos about getting braces can also make the transition easier for young ones.",
  },
  {
    title: "Are there benefits to braces besides having straighter teeth?",
    definition:
      "Contrary to popular belief, braces are not purely cosmetic. They can significantly improve oral function. Also, braces are no longer as intrusive or uncomfortable as they once were, thanks to technological advancements.",
  },
  {
    title: "What are the psychological benefits of braces?",
    definition:
      "A beautiful smile does more than boost your appearance; it elevates your self-esteem and contributes to better mental health. Studies indicate that people with aligned teeth often feel more confident.",
  },
  {
    title: "How do I prepare for life after braces?",
    definition:
      "Congratulations, your braces are off! But the journey doesn’t end here. Retainers are crucial in maintaining your new smile. Retainers could be removable or fixed, depending on your orthodontist’s recommendation. Regular follow-up visits ensure that retainers are worn properly and that your teeth remain in their new, correct positions.",
  },
  {
    title: "Pre-braces dental check-up: is it necessary?",
    definition:
      "Yes, visiting your family dentist for a thorough cleaning and check-up before applying braces is essential. Your orthodontist will advise you on how far in advance to schedule this. Remember to avoid having fluoride treatments with your dentist two weeks before getting your braces, as the fluoride may interfere with the braces adhering to the teeth.",
  },
  {
    title: "How many appointments are required during clear aligner treatment?",
    definition:
      "Regular check-ups with your orthodontist are recommended throughout the treatment process to make sure teeth are moving appropriately and to address any issues that may arise. Some orthodontic offices offer remote monitoring options that can minimize the number of appointments needed in person. While this can be an added convenience for you, it also allows the orthodontist to be more regularly updated and involved with your ongoing treatment.",
  },
  {
    title: "Is getting aligners faster than getting braces?",
    definition:
      "Not necessarily. Clear aligners are not usually fabricated on site, and delivery from the manufacturer can take 4-6 weeks. Combined with initial scans, placing attachments, and educating the user on how to properly wear and care for them, aligners can take just as long as braces.",
  },
  {
    title: "What if a problem comes up and I can’t make my payment?",
    definition:
      "If you are unable to make your payment(s) for orthodontic treatment, communicate that to your orthodontist immediately. The orthodontist needs to be aware of this change in your circumstances.",
  },
  {
    title: "Do I have to sign a contract?",
    definition:
      "Typically, a contract is signed when you decide to move forward with orthodontic treatment.",
  },
  {
    title: "Do orthodontists take credit cards?",
    definition:
      "Many orthodontists accept major credit cards. Check with your orthodontist’s office about whether credit cards are accepted as payment, and if so, which ones.",
  },
  {
    title:
      "I do not have employer-provided insurance for orthodontic treatment. Can I buy insurance myself?",
    definition: "Yes, you can purchase orthodontic insurance.",
  },
  {
    title:
      "Can I use my flexible spending account or health savings account funds for orthodontic treatment?",
    definition:
      "Yes, funds from flexible spending accounts and health savings accounts can be used to pay for orthodontic treatment. Talk to your orthodontist about how to make the best use of your benefits.",
  },
  {
    title: "Do I have to make a down payment?",
    definition:
      "A down payment may or may not be required. Speak with your orthodontist or their team members about payment plans that are offered.",
  },
  {
    title: "Do orthodontists offer payment plans?",
    definition:
      "Yes, most orthodontists offer a variety of payment plans to make orthodontic care fit your budget. Payment plans offered can vary from orthodontist to orthodontist.",
  },
  {
    title: "What does the orthodontist’s fee cover?",
    definition:
      "Some orthodontists’ fees are all-inclusive, and some are not. Talk to your orthodontist and ask what his/her fee covers, and if there is anything the fee does not cover.",
  },
  {
    title:
      "My orthodontist wants to do something called enamel stripping to make my teeth smaller. I have never heard of this. Is this something new? Is it safe?",
    definition:
      "This procedure goes by many names: enamel stripping; interproximal reduction; slenderizing; reproximation and selective reduction. The goal is to remove some of the outer tooth surface (enamel) to acquire more space for your teeth.",
  },
  {
    title:
      "My dentist said I need to have some missing teeth replaced, but I need orthodontic treatment first – why?",
    definition:
      "Your dentist is probably recommending orthodontic treatment so that you can reach optimal dental health. Many complicated tooth restorations, such as crowns, bridges and implants, can be best accomplished when the remaining teeth are properly aligned and the bite is correct.",
  },
  {
    title: "Can I play sports during treatment?",
    definition: "Yes, but be sure to wear a mouth guard.",
  },
  {
    title:
      "Once I finish orthodontic treatment, my teeth will remain straight forever, right?",
    definition:
      "Teeth move throughout one’s lifetime, making it important to wear retainers as prescribed by your orthodontist to maintain your healthy, beautiful smile.",
  },
  {
    title: "Are braces the only way orthodontists can move my teeth?",
    definition:
      "In addition to braces, orthodontists use appliances such as aligners to move teeth. Consult an orthodontist to learn what type of appliance can correct your orthodontic problem.",
  },
  {
    title:
      "I’ve been seeing ads for straightening my teeth at home. Why not give it a shot?",
    definition:
      "Moving teeth is a complex biological process and there is a lot that goes into it. That’s why orthodontists must go to school for so many years to be licensed to practice this specialty. Many AAO orthodontists offer free or low-cost initial consultations. Isn’t your dental health worth a consultation with an orthodontist?",
  },
  {
    title: "Can sports be played during orthodontic treatment?",
    definition:
      "Yes. But talk to your orthodontist about the type of mouth guard to wear.",
  },
  {
    title:
      "When should I notify my orthodontist that there is a problem with my treatment?",
    definition:
      "If you notice a bracket is loose or if a wire has worked itself out of place, or if there is unusual discomfort, notify your orthodontist immediately.",
  },
  {
    title: "Are there orthodontic emergencies?",
    definition:
      "Occasionally things happen to braces or aligners during orthodontic treatment. They may require a call or an unforeseen visit to the orthodontist – what your orthodontist will consider an 'emergency visit.'",
  },
  {
    title: "How much work/school will I miss for my treatment?",
    definition:
      "There may be some time away from work or school during your orthodontic treatment, but your orthodontist will do his/her best to minimize it. If you have braces, the longest appointments will be to place and remove your braces, and will likely be scheduled during the work day. Appointments to adjust braces or pick up a new set of aligners, scheduled every 6 to 10 weeks, are usually short.",
  },
  {
    title: "Do I need to see a dentist during orthodontic treatment?",
    definition:
      "It’s critical that you continue seeing your family dentist during orthodontic treatment. Your dentist will provide professional cleanings and check-ups, and like your orthodontist, will keep an eye on oral health. Visit your dentist at least every six months during orthodontic treatment, or more often, if recommended.",
  },
  {
    title: "Is all orthodontic treatment done with braces?",
    definition:
      "Not these days. Among the choices are braces, which consist of brackets and wires, and, for some people, clear aligners.",
  },
];
